<app-header></app-header>
<main class="main-content">
  <!------main-content------>
  <!-------slider--section------>
  <section class="banner type_two" style="background:url(assets/image/main-slider/slider-2-1.jpg)">
   <div class="container">
      <div class="row">
         <div class="col-lg-6 d-flex  pr_0">
            <div class="content_outer">
               <div class="inner_box">
                  <h6 class="wow slideInDown" data-wow-delay="100ms" data-wow-duration="1500ms">You are not feeling well?</h6>
                  <h1 class="wow slideInLeft font-responsive-heading" data-wow-delay="200ms" data-wow-duration="1500ms">COVID-19 Registration</h1>
                  <p class="wow slideInLeft animated font-responsive-para" data-wow-delay="300ms" data-wow-duration="1500ms" style="visibility: visible; animation-duration: 1500ms; animation-delay: 300ms; animation-name: slideInLeft;">
                     Get registered with us for the Covid-19 test. Our laboratory performs PCR tests for Coronavirus for visitors that would come to Equatorial Guinea as well as for those traveling from Equatorial Guinea to countries requiring PCR tests.
                     
                     The traveller will be able to receive it before departure. 
                     
                     Countries requiring a PCR test upon entry usually request it with a statute of limitations of at least 48 hours prior to departure.
                     
                     We recommend taking testing 48 hours in advance or in accordance with the regulations of the country you are flying to.
                  </p> 
                  
                  

                  
               </div>
               <ul class="button-reg button-reg-bot font-10">
               
                  <li><a class="color-3" [routerLink]="['/inboundregistration']"><!-- <img src="assets/image/arri.png"> --> <i class="fas fa-map-marker-alt"></i> Arriving Equatorial Guinea</a></li>
                  <li><a class="color-3" [routerLink]="['/outboundregistration']"><!--<img src="assets/image/depa.png"> --> <i class="fas fa-plane"></i> Departing Equatorial Guinea</a></li>
               
               </ul>
            </div>
         </div>
         <div class="col-lg-6">
            <div class="image_box wow slideInDown hide-in-mobile" data-wow-delay="300ms" data-wow-duration="1500ms">
               <img src="assets/image/main-slider/slider--graphic-2-1.png" class="img-fluid" alt="img" />
            </div>
         </div>
      </div>
   </div>
</section>
  <!-------slider--section-end----->
  <!-----------counter--------------->
  <section class="counter type_two wow fadeIn" data-wow-delay="600ms" data-wow-duration="1500ms">
     <div class="container">
        <div class="counter_outer_box">
           <div class="row">
              <!---------row----------->
              <div class="col-lg-4 col-md-12">
                 <!---------col----------->
                 <div class="heading tp_one">
                    <h6>Worldwide Tracker</h6>
                    <h1 class="font-responsive-heading">Pandemic Statistics</h1>
                    <!-- <p>Last updated: March 27, 2020, 14:49 GMT</p> -->
                    <p>Last updated: {{lastUpdated | date}}</p>
                 </div>
                 <!---------col-end---------->
              </div>
              <div class="col-lg-8 col-md-12 d-flex">
                 <!---------col----------->
                 <div class="counter_box_outer">
                    <div class="counter_box type_two one">
                       <div class="image_box">
                          <img src="assets/image/icon-1.jpg" class="img-fluid" alt="svg_iage" />
                       </div>
                       <div class="text_box">
                          <h2><span class="font-25" >{{allCase}}</span></h2>
                          <h6>Coronavirus Cases</h6>
                       </div>
                    </div>
                    <div class="counter_box type_two two">
                       <div class="image_box">
                          <img src="assets/image/icon-2.jpg" class="img-fluid" alt="svg_iage" />
                       </div>
                       <div class="text_box">
                          <h2><span class="font-25" >{{allDeath}}</span></h2>
                          <h6>Deaths</h6>
                       </div>
                    </div>
                    <div class="counter_box type_two three">
                       <div class="image_box">
                          <img src="assets/image/icon-3.jpg" class="img-fluid" alt="svg_iage" />
                       </div>
                       <div class="text_box">
                          <h2><span class="font-25" >{{allRecover}}</span></h2>
                          <h6>Recovered</h6>
                       </div>
                    </div>
                 </div>
                 <!---------col-end---------->
              </div>
              <!----------row-end---------->
           </div>
        </div>
     </div>
  </section>
  <!-----------counter-end-------------->
  <!-----------about--------------->
  <section class="about type_two pdt_100 pdb_100 wow fadeIn" data-wow-delay="600ms" data-wow-duration="1500ms">
     <div class="container">
        <div class="row">
           <!---------row----------->
           <div class="col-lg-6 col-md-12 d-flex">
              <!---------col----------->
              <div class="about_content">
                 <div class="heading tp_one">
                    <h6>COVID-19 the disease </h6>
                    <h1 class="font-responsive-heading"> About the Coronavirus</h1>
                 </div>
                 <p class="font-responsive-para"> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors.
                 </p>
                 <p class="last font-responsive-para"> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p>
              </div>
              <!---------col-end---------->
           </div>
           <div class="col-lg-6 col-md-12 hide-in-mobile">
              <!---------col----------->
              <div class="image_box one">
                 <img src="assets/image/resources/about-2-1.png" class="img-fluid" alt="img" />
              </div>
              <!---------col-end---------->
           </div>
           <!----------row-end---------->
        </div>
        
     </div>
  </section>

  <section class="protect type_two pdt_100  pdb_100 wow fadeIn" data-wow-delay="600ms" data-wow-duration="1500ms">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-12 col-md-12">
            <!---------col----------->
            <div class="heading text-center tp_one">
               <h6> What you need to do</h6>
               <h1 class="font-responsive-heading">How to protect yourself?</h1>
               <p> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
      <div class="row">
         <!---------row----------->
         <div class="col-lg-4 col-md-6">
            <!---------col----------->
            <div class="protect_box_left">
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="content_box">
                     <h2>Stay at home</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-1.png" class="img-fluid" alt="img" />
                     <span class="fa fa-check"></span>

                  </div>
               </div>
               <!--------protext-box-end------->
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="content_box">
                     <h2>Use mask</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-2.png" class="img-fluid" alt="img" />
                     <span class="fa fa-check"></span>
                  </div>
               </div>
               <!--------protext-box-end------->
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="content_box">
                     <h2>Wash your hands</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-3.png" class="img-fluid" alt="img" />
                     <span class="fa fa-check"></span>
                  </div>
               </div>
               <!--------protext-box-end------->
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="content_box">
                     <h2>Drink often</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-4.png" class="img-fluid" alt="img" />
                     <span class="fa fa-check"></span>
                  </div>
               </div>
               <!--------protext-box-end------->
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-12 hide-img-320">
            <!---------col----------->
            <div class="content_image_box ">
               <img src="assets/image/resources/protect-2-1.png" class="img-fluid" alt="img" />
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6">
            <!---------col----------->
            <div class="protect_box_right">
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-5.png" class="img-fluid" alt="img" />
                     <span class="fa fa-times worng"></span>
                  </div>
                  <div class="content_box">
                     <h2>Social distance </h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
               </div>
               <!--------protext-box-end------->
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-6.png" class="img-fluid" alt="img" />
                     <span class="fa fa-times worng"></span>
                  </div>
                  <div class="content_box">
                     <h2>Avoid animals</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
               </div>
               <!--------protext-box-end------->
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-7.png" class="img-fluid" alt="img" />
                     <span class="fa fa-times worng"></span>
                  </div>
                  <div class="content_box">
                     <h2>Don't touch your face</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
               </div>
               <!--------protext-box-end------->
               <!--------protext-box-------->
               <div class="protect_box type_two">
                  <div class="image_box">
                     <img src="assets/image/resources/protect-box-2-8.png" class="img-fluid" alt="img" />
                     <span class="fa fa-times worng"></span>
                  </div>
                  <div class="content_box">
                     <h2>Avoid handshaking</h2>
                     <p> It is a long established fact that a reader will.</p>
                  </div>
               </div>
               <!--------protext-box-end------->
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
   </div>
</section>

<section class="spreading type_two  pdt_100  pdb_60">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-12 col-md-12">
            <!---------col----------->
            <div class="heading text-center tp_one">
               <h6>How can spreading Coronavirus </h6>
               <h1 class="font-responsive-heading">How is it transmitted COVID-19?</h1>
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
      <div class="row">
         <!---------row----------->
         <div class="col-lg-4 col-md-6 col-sm-12">
            <!---------col----------->
            <div class="spreading_box type_two wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
               <div class="image_box">
                  <img src="assets/image/resources/spreading-1-1.png" class="img-fluid" alt="img" />
               </div>
               <div class="content_box">
                  <h2 class="font-responsive-heading">Air by cough or sneeze </h2>
                  <p>Travel restrictions or screening air travellers for high temperature (fever) may help to prevent the SARS infection being spread.</p>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6 col-sm-12">
            <!---------col----------->
            <div class="spreading_box type_two wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
               <div class="image_box">
                  <img src="assets/image/resources/spreading-1-2.png" class="img-fluid" alt="img" />
               </div>
               <div class="content_box">
                  <h2 class="font-responsive-heading">Animal contact </h2>
                  <p>Travel restrictions or screening air travellers for high temperature (fever) may help to prevent the SARS infection being spread.</p>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6 col-sm-12">
            <!---------col----------->
            <div class="spreading_box type_two wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
               <div class="image_box">
                  <img src="assets/image/resources/spreading-1-3.png" class="img-fluid" alt="img" />
               </div>
               <div class="content_box">
                  <h2 class="font-responsive-heading">Personal contact </h2>
                  <p>Travel restrictions or screening air travellers for high temperature (fever) may help to prevent the SARS infection being spread.</p>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6 col-sm-12">
            <!---------col----------->
            <div class="spreading_box type_two  wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
               <div class="image_box">
                  <img src="assets/image/resources/spreading-1-4.png" class="img-fluid" alt="img" />
               </div>
               <div class="content_box">
                  <h2 class="font-responsive-heading">Contaminated objects</h2>
                  <p>Travel restrictions or screening air travellers for high temperature (fever) may help to prevent the SARS infection being spread.</p>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6 col-sm-12">
            <!---------col----------->
            <div class="spreading_box type_two  wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
               <div class="image_box">
                  <img src="assets/image/resources/spreading-1-5.png" class="img-fluid" alt="img" />
               </div>
               <div class="content_box">
                  <h2 class="font-responsive-heading">Droplets from infected persons</h2>
                  <p>Travel restrictions or screening air travellers for high temperature (fever) may help to prevent the SARS infection being spread.</p>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6 col-sm-12">
            <!---------col----------->
            <div class="spreading_box type_two  wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
               <div class="image_box">
                  <img src="assets/image/resources/spreading-1-6.png" class="img-fluid" alt="img" />
               </div>
               <div class="content_box">
                  <h2 class="font-responsive-heading">Touching  infected surfaces</h2>
                  <p>Travel restrictions or screening air travellers for high temperature (fever) may help to prevent the SARS infection being spread.</p>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
   </div>
</section>

<section class="experts type_one pdt_100  pdb_70">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-12 col-md-12">
            <!---------col----------->
            <div class="heading text-center tp_one">
               <h6> Ask for advice and consult our doctors </h6>
               <h1 class="font-responsive-heading">Meet our Experts</h1>
               <p>Are you washing your hands properly? Most of us know how important it is to practise good hand hygiene. <br class="md_display_none"> But just because you're washing your hands often, doesn't mean that you're washing them
                  well.
               </p>
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
      <div class="row">
         <!---------row----------->

         <!-- Item Div Start -->
         <div class="col-lg-4 col-sm-6">
            <div class="expert_box type_one">
               <div class="image_box">
                  <img src="assets/image/resources/expert-2-1.jpg" class="img-fluid" alt="experts" />
               </div>
               <div class="content_box">
                  <div class="expert_details">
                     <h2><a href="#">Kelly Stark</a></h2>
                     <p> Epidemiological expert</p>
                  </div>
                  <div class="expert_contact">
                     <h6><span>Email: </span> <a href="#"> kellystark@domain.net</a></h6>
                     <h6><span>Skype ID: </span><a href="#"> domain.stark</a></h6>
                     <a href="#" class="theme_btn tp_one"><span class="linearicons-telephone"></span>  +240 (8) 8234 3555</a>
                  </div>
                  <ul class="media">
                     <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                     <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                     <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                  </ul>
               </div>
            </div>
         </div>



         <!-- Item Div Start -->
         <div class="col-lg-4 col-sm-6">
            <div class="expert_box type_one">
               <div class="image_box">
                  <img src="assets/image/resources/expert-2-3.jpg" class="img-fluid" alt="experts" />
               </div>
               <div class="content_box">
                  <div class="expert_details">
                     <h2><a href="#">Kelly Stark</a></h2>
                     <p> Epidemiological expert</p>
                  </div>
                  <div class="expert_contact">
                     <h6><span>Email: </span> <a href="#"> kellystark@domain.net</a></h6>
                     <h6><span>Skype ID:</span><a href="#">   domain.stark</a></h6>
                     <a href="#" class="theme_btn tp_one"><span class="linearicons-telephone"></span>  +240 (8) 8234 3555</a>
                  </div>
                  <ul class="media">
                     <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                     <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                     <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                  </ul>
               </div>
            </div>
         </div>


         <!-- Item Div Start -->
         <div class="col-lg-4 col-sm-6">
            <div class="expert_box type_one">
               <div class="image_box">
                  <img src="assets/image/resources/expert-2-2.jpg" class="img-fluid" alt="experts" />
               </div>
               <div class="content_box">
                  <div class="expert_details">
                     <h2><a href="#">Kelly Stark</a></h2>
                     <p> Epidemiological expert</p>
                  </div>
                  <div class="expert_contact">
                     <h6><span>Email: </span> <a href="#"> kellystark@domain.net</a></h6>
                     <h6><span>Skype ID:</span><a href="#">   domain.stark</a></h6>
                     <a href="#" class="theme_btn tp_one"><span class="linearicons-telephone"></span>  +240 (8) 8234 3555</a>
                  </div>
                  <ul class="media">
                     <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                     <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                     <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                  </ul>
               </div>
            </div>
         </div>



         <!-- Item Div Start -->
         <div class="col-lg-4 col-sm-6">
                     <div class="expert_box type_one">
                        <div class="image_box">
                           <img src="assets/image/resources/expert-2-1.jpg" class="img-fluid" alt="experts" />
                        </div>
                        <div class="content_box">
                           <div class="expert_details">
                              <h2><a href="#">Kelly Stark</a></h2>
                              <p> Epidemiological expert</p>
                           </div>
                           <div class="expert_contact">
                              <h6><span>Email: </span> <a href="#"> kellystark@domain.net</a></h6>
                              <h6><span>Skype ID:</span><a href="#">   domain.stark</a></h6>
                              <a href="#" class="theme_btn tp_one"><span class="linearicons-telephone"></span>  +240 (8) 8234 3555</a>
                           </div>
                           <ul class="media">
                              <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                              <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                           </ul>
                        </div>
                     </div>
         </div>



         <!-- Item Div Start -->
         <div class="col-lg-4 col-sm-6">
            <div class="expert_box type_one">
               <div class="image_box">
                  <img src="assets/image/resources/expert-2-2.jpg" class="img-fluid" alt="experts" />
               </div>
               <div class="content_box">
                  <div class="expert_details">
                     <h2><a href="#">Kelly Stark</a></h2>
                     <p> Epidemiological expert</p>
                  </div>
                  <div class="expert_contact">
                     <h6><span>Email: </span> <a href="#"> kellystark@domain.net</a></h6>
                     <h6><span>Skype ID:</span><a href="#">   domain.stark</a></h6>
                     <a href="#" class="theme_btn tp_one"><span class="linearicons-telephone"></span>  +240 (8) 8234 3555</a>
                  </div>
                  <ul class="media">
                     <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                     <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                     <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                  </ul>
               </div>
            </div>
         </div>


         <!-- Item Div Start -->
         <div class="col-lg-4 col-sm-6">
            <div class="expert_box type_one">
               <div class="image_box">
                  <img src="assets/image/resources/expert-2-3.jpg" class="img-fluid" alt="experts" />
               </div>
               <div class="content_box">
                  <div class="expert_details">
                     <h2><a href="#">Kelly Stark</a></h2>
                     <p> Epidemiological expert</p>
                  </div>
                  <div class="expert_contact">
                     <h6><span>Email: </span> <a href="#"> kellystark@domain.net</a></h6>
                     <h6><span>Skype ID:</span><a href="#">   domain.stark</a></h6>
                     <a href="#" class="theme_btn tp_one"><span class="linearicons-telephone"></span>  +240 (8) 8234 3555</a>
                  </div>
                  <ul class="media">
                     <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                     <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                     <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                  </ul>
               </div>
            </div>
         </div>

         <!----------row-end---------->
      </div>
   </div>
</section>


<section class="apps type_one   pdt_100">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-6 col-md-12 hide-in-mobile">
            <!---------col----------->
            <div class="image_box">
               <img src="assets/image/resources/apps-1-1.png" class="img-fluid" alt="img" />
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-6 col-md-12 d-flex">
            <!---------col----------->
            <div class="app_content">
               <div class="heading  tp_one">
                  <h6 class="white-color">Need support? </h6>
                  <h1 class="white-color"> Download app now!</h1>
                  <p class="white-color">Use our application to stay informated about news purposes, get updates,<br class="md_display_none"> tracking tipps and get assistance if you need any help!</p>
               </div>
               <div class="apps_link">
                  <ul>
                     <li>
                        <a href="#"><img src="assets/image/resources/apps-btn-1-1.png" class="img-fluid" alt="apps" /></a>
                     </li>
                     <li>
                        <a href="#"><img src="assets/image/resources/apps-btn-1-2.png" class="img-fluid" alt="apps" /></a>
                     </li>
                  </ul>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
   </div>
</section>



  
  
<!-- Footer -->

<app-footer></app-footer>


  <!------main-content-end----->
</main>
<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>